/// <amd-module name="TFS/Admin/Groups/Pivots/ServicePrincipals/Redux/ServicePrincipalsPivotReducers" />
import produce from "immer";
import { SearchStatus } from "TFS/Admin/Groups/Common/Constants";
import { IServicePrincipalsPivotState } from "TFS/Admin/Groups/Common/Contracts";
import * as Resources from "TFS/Admin/Groups/Common/Resources";
import { ServicePrincipalsPivotActions, ServicePrincipalsPivotActionTypes } from "TFS/Admin/Groups/Pivots/ServicePrincipals/Redux/ServicePrincipalsPivotActions";
import { MessageCardSeverity } from "VSSUI/MessageCard";

export function servicePrincipalsPivotReducer(state: IServicePrincipalsPivotState, action: ServicePrincipalsPivotActions): IServicePrincipalsPivotState {
    return produce(state || {}, draft => {
        switch (action.type) {
            case ServicePrincipalsPivotActionTypes.InitView: {
                draft.data = {
                    totalIdentityCount: 0,
                    identities: [],
                    moreData: true
                };
                draft.searchResult = {
                    keyword: "",
                    resultItems: [],
                    status: SearchStatus.None,
                    hasMore: false
                };
                draft.messageCardText = undefined;
                break;
            }

            case ServicePrincipalsPivotActionTypes.InitialServicePrincipalsLoadSucceeded: {
                var { servicePrincipals, continuationToken } = action.payload;

                draft.data = {
                    totalIdentityCount: servicePrincipals.length,
                    identities: servicePrincipals,
                    moreData: continuationToken && continuationToken.length > 0 ? true : false,
                    continuationToken: action.payload.continuationToken
                };
                draft.initComplete = true;
                draft.loading = false;
                break;
            }

            case ServicePrincipalsPivotActionTypes.ServicePrincipalsLoadFailed: {
                draft.messageCardText = Resources.ServicePrincipalsLoadFailed;
                draft.messageCardSeverity = MessageCardSeverity.Error;
                draft.data.moreData = false;
                draft.initComplete = false;
                draft.loading = false;
                break;
            }

            case ServicePrincipalsPivotActionTypes.FetchMoreServicePrincipalsSucceeded: {
                var { servicePrincipals, continuationToken } = action.payload;

                draft.data = {
                    totalIdentityCount: draft.data.totalIdentityCount + servicePrincipals.length,
                    identities: draft.data.identities.slice(0, draft.data.identities.length).concat(servicePrincipals),
                    moreData: continuationToken && continuationToken.length > 0 ? true : false,
                    continuationToken: continuationToken
                };
                draft.loading = false;
                draft.initComplete = false;
                break;
            }

            case ServicePrincipalsPivotActionTypes.ServicePrincipalOperationStatus: {
                var { resultMessage, severity } = action.payload;
                draft.messageCardText = resultMessage;
                draft.messageCardSeverity = severity;
                break;
            }

            case ServicePrincipalsPivotActionTypes.DismissMessageCard: {
                draft.messageCardText = undefined;
                break;
            }

            case ServicePrincipalsPivotActionTypes.SearchServicePrincipals: {
                updateSearchStatus(draft, SearchStatus.Searching);
                break;
            }

            case ServicePrincipalsPivotActionTypes.UpdateSearchStatus: {
                updateSearchStatus(draft, action.payload);
                break;
            }

            case ServicePrincipalsPivotActionTypes.UpdateSearchResult: {
                updateSearchResult(draft, action.payload.keyword, action.payload.result, action.payload.hasMore);
                break;
            }

            default:
                return state;
        }
    });
}

function updateSearchStatus(state: IServicePrincipalsPivotState, searchStatus: SearchStatus) {
    const { searchResult } = state;
    if (!searchResult) {
        return;
    }
    if (searchStatus === SearchStatus.None) {
        searchResult.resultItems = [];
        searchResult.keyword = "";
    }
    searchResult.status = searchStatus;
}

function updateSearchResult(state: IServicePrincipalsPivotState, keyword: string, results: any[], hasMore: boolean) {
    if (!keyword || !state.searchResult) {
        return;
    }
    state.searchResult = {
        keyword,
        resultItems: results,
        status: SearchStatus.Completed,
        hasMore
    };
}
